import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { formatWholeDollars } from '../../lib/utils/formatters';

// Remembered per dismissKey for the browser tab, so returning to terms (e.g.
// "Select a different term" on Confirm) doesn't bring the banner back.
const dismissalStorageKey = (dismissKey) =>
  `ck_approval_banner_dismissed_${dismissKey}`;

const wasDismissed = (dismissKey) => {
  if (dismissKey == null) return false;
  try {
    return sessionStorage.getItem(dismissalStorageKey(dismissKey)) === 'true';
  } catch (e) {
    return false;
  }
};

const rememberDismissal = (dismissKey) => {
  if (dismissKey == null) return;
  try {
    sessionStorage.setItem(dismissalStorageKey(dismissKey), 'true');
  } catch (e) {
    // Storage unavailable: the dismissal still lasts while the banner is mounted
  }
};

export default function ApprovalBanner({ amount, dismissKey, onDismiss }) {
  const [dismissed, setDismissed] = useState(() => wasDismissed(dismissKey));
  if (dismissed) return null;

  const title =
    Number.isFinite(amount) && amount > 0
      ? `You're approved for ${formatWholeDollars(amount)}!`
      : "You're approved!";

  return (
    <div
      role="status"
      data-testid="approval-banner"
      className="my-4 rounded-lg border border-success/30 bg-background-success px-4 py-3 flex items-start gap-3"
    >
      <FontAwesomeIcon
        icon={['far', 'circle-check']}
        className="text-success text-xl mt-0.5"
        aria-hidden
      />
      <div className="flex-1">
        <div className="font-bold text-success">{title}</div>
        <div className="text-sm text-success">
          You can use your approved credit line right now. Choose how to pay
          below.
        </div>
      </div>
      <button
        type="button"
        aria-label="Dismiss approval notification"
        className="text-success p-2 -m-2"
        onClick={() => {
          setDismissed(true);
          rememberDismissal(dismissKey);
          onDismiss?.();
        }}
      >
        <FontAwesomeIcon icon={['fas', 'times']} />
      </button>
    </div>
  );
}
